import { render, staticRenderFns } from "./ProductsSummary.vue?vue&type=template&id=16524c86"
import script from "./ProductsSummary.vue?vue&type=script&lang=js"
export * from "./ProductsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports